import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { memo } from 'react';

import { Tooltip } from '@/components/Tooltip';

const CNAERecordLine = ({ name, summary, isSelected, forceSummary }) => {
  
  return (
    <div className={classNames({ 'truncate': !forceSummary })}>
      <div className={classNames('flex items-center', { 'truncate': !forceSummary })}>
        <div className={classNames('font-semibold', { 'truncate': !forceSummary })}>{name}</div>
      </div>
      {(!isSelected || forceSummary) &&
      <Tooltip
        title={summary || name}
        placement="left"
        className={classNames({ 'truncate': !forceSummary })}>
        <div className={classNames('text-xs', { 'truncate': !forceSummary })}>{summary}</div>
      </Tooltip>}
    </div>
  );
  
};

CNAERecordLine.propTypes = {
  name: PropTypes.string,
  summary: PropTypes.string,
  isSelected: PropTypes.bool,
  forceSummary: PropTypes.bool,
};

CNAERecordLine.defaultProps = {};

export default memo(CNAERecordLine);
